import React, { useState, useRef } from 'react';
import {
    createStyles,
    makeStyles,
    Theme,
} from '@material-ui/core';
import {
    List,
    ListCell,
    ListContainer,
    ListHeader,
    ListItem,
} from '../../../components/List';
import { FrontVod } from '../../../data/FrontVod';
import { useWindowResizeEffect } from '../../../units/useWindowResizeEffect';
import { Button } from '../../../components/Button';

type FeedbackListProps = {
    feedbackList: FrontVod[],
    onItemClick?: (item: FrontVod) => void,
    onItemMoreClick?: (item: FrontVod) => void,
    listRef?: React.RefObject<HTMLDivElement>,
};

FeedbackList.defaultProps = {
    onItemClick: () => {},
    onItemMoreClick: () => {},
    listRef: null,
};

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        '& .MuiTableCell-stickyHeader': {
            backgroundColor: theme.palette.background.paper,
        },
    },
    container: {
        height: '100%',
    },
    questionCol: {
        whiteSpace: 'nowrap',
        overflowX: 'hidden',
    },
}));

function FeedbackList(props: FeedbackListProps): React.ReactElement {
    const {
        feedbackList,
        onItemClick = FeedbackList.defaultProps.onItemClick,
        onItemMoreClick = FeedbackList.defaultProps.onItemMoreClick,
        listRef,
    } = props;
    const classes = useStyles();

    const rootEl = useRef<HTMLDivElement>(null);
    const [containerHeight, setContainerHeight] = useState('100%');

    useWindowResizeEffect(() => {
        if (rootEl && rootEl.current) {
            setContainerHeight(`${rootEl.current.clientHeight - 56}px`);
        }
    }, [rootEl]);

    return (
        <div className={classes.root}>
            <ListContainer className={classes.container} containerRef={rootEl}>
                <ListHeader>
                    <ListCell width={120}>回饋日期</ListCell>
                    <ListCell width={160}>問題內容</ListCell>
                    <ListCell width={100}>客服回覆</ListCell>
                </ListHeader>
                <List containerHeight={containerHeight} containerRef={listRef}>
                    {feedbackList.map((item) => (
                        <ListItem onClick={() => onItemClick(item)}>
                            <ListCell width={120}>{item.create_date}</ListCell>
                            <ListCell width={160} className={classes.questionCol}>{item.question}</ListCell>
                            <ListCell width={100}>
                                <Button onClick={() => onItemMoreClick(item)} size="small" variant="outlined">More</Button>
                            </ListCell>
                        </ListItem>
                    ))}
                </List>
            </ListContainer>
        </div>
    );
}

export { FeedbackList };
